import type { Mapper } from '@/core/mapper/base-mapper';
import type {
	ErgonomicWorkAnalysisImage,
	GetErgonomicWorkAnalysisImagesResponseDTO
} from '@/core/dto/ergonomic-work-analisys/get-image-list';

class GetErgonomicWorkAnalysisImagesMapper implements Mapper<ErgonomicWorkAnalysisImage[]> {
	constructor(private readonly data: GetErgonomicWorkAnalysisImagesResponseDTO[]) {}

	toDomain(): ErgonomicWorkAnalysisImage[] {
		return this.data.map((image) => ({
			uid: image.id,
			name: image.location || 'image',
			description: image.description || '',
			status: 'done',
			url: image.image_url || image.location
		}));
	}
}

export default GetErgonomicWorkAnalysisImagesMapper;
